import http from 'utils/http';
import { getIndustriesUrl, getSubIndustriesUrl } from './apiUrl';
import { IndustriesResponse } from './types';

export async function getIndustries(): Promise<IndustriesResponse[]> {
  const data = await http.get(getIndustriesUrl());
  return data.data;
}

export async function getSubIndustries(id: number | string): Promise<IndustriesResponse[]> {
  const data = await http.get(getSubIndustriesUrl(id));
  return data.data;
}
